/* global BROWSERLIST_REGEXP */

export default function isSupported() {
  // BROWSERLIST_REGEXP comes from webpack
  return BROWSERLIST_REGEXP.test(navigator.userAgent);
}
